<wdx-alert themeColor="primary">
    <div class="d-flex justify-content-between align-items-center w-100">
        <div class="d-flex align-items-center">
            <div>
                @if (title) {
                    <h6 class="fw-bold">{{ title }}</h6>
                }
                <span>{{ selectedCount }}</span>
                @if (totalItems) {
                    <span>&nbsp;of {{ totalItems }}</span>
                }
                <span>&nbsp;Selected</span>
            </div>
        </div>
        <div class="d-flex align-items-stretch">
            @if (contentProjectActions) {
                <ng-content></ng-content>
            } @else {
                @if (actionButtons?.length) {
                    <div class="d-flex align-items-center">
                        @for (
                            actionButton of actionButtons;
                            track $index;
                            let first = $first
                        ) {
                            <molecule-action-button
                                class="me-1"
                                btnClass="btn-primary"
                                size="md"
                                [ngbPopover]="
                                    actionButton.label
                                        | translateTokenisedString
                                "
                                [triggers]="POP_UP_TRIGGER.triggers"
                                [container]="POP_UP_TRIGGER.container"
                                [openDelay]="POP_UP_TRIGGER.openDelay"
                                [closeDelay]="POP_UP_TRIGGER.closeDelay"
                                [disablePopover]="!actionButton.label"
                                [actionButton]="actionButton"
                                (onClick)="onActionButtonClicked(actionButton)"
                            ></molecule-action-button>
                        }
                    </div>
                } @else {
                    <div class="d-flex align-items-center m-2">
                        <div>No bulk actions available</div>
                    </div>
                }
            }

            <atom-close
                btnClass="btn btn-primary"
                ngbPopover="Close"
                [triggers]="POP_UP_TRIGGER.triggers"
                [container]="POP_UP_TRIGGER.container"
                [openDelay]="POP_UP_TRIGGER.openDelay"
                [closeDelay]="POP_UP_TRIGGER.closeDelay"
                (click)="onClose()"
            ></atom-close>
        </div>
    </div>
</wdx-alert>
